import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { IconType } from 'react-icons';

export interface CreateActionConfig {
  icon?: IconType;
  label?: string;
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

interface CreateActionContextValue {
  action: CreateActionConfig | null;
  setAction: (config: CreateActionConfig | null) => void;
}

const CreateActionContext = createContext<CreateActionContextValue | undefined>(undefined);

export function CreateActionProvider({ children }: { children: ReactNode }) {
  const [action, setAction] = useState<CreateActionConfig | null>(null);

  const value = useMemo<CreateActionContextValue>(
    () => ({
      action,
      setAction,
    }),
    [action]
  );

  return <CreateActionContext.Provider value={value}>{children}</CreateActionContext.Provider>;
}

export function useCreateAction() {
  const context = useContext(CreateActionContext);
  if (!context) {
    throw new Error('useCreateAction must be used within a CreateActionProvider');
  }
  return context.action;
}

export function useSetCreateAction() {
  const context = useContext(CreateActionContext);
  if (!context) {
    throw new Error('useSetCreateAction must be used within a CreateActionProvider');
  }
  return context.setAction;
}
